<div class="container">
  <div
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-md="space-between center"
  >
    <div fxFlex="auto" fxLayoutAlign="center">
      <mat-card class="card" fxFlex="30" fxFlex.lt-sm="100">
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          fxLayoutAlign.lt-md="center center"
          class="title__sub-title"
        >
          <mat-icon class="card__icon">assignment</mat-icon>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          fxLayoutAlign.lt-md="center center"
          class="title__sub-title"
        >
          <a [routerLink]="['/serviceRequest/list']">
            <div>Listagem de O.S</div>
          </a>
        </div>
      </mat-card>
    </div>

    <div fxFlex="auto" fxLayoutAlign="center">
      <mat-card class="card" fxFlex="30" fxFlex.lt-sm="100">
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          fxLayoutAlign.lt-md="center center"
          class="title__sub-title"
        >
          <mat-icon class="card__icon">library_add</mat-icon>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          fxLayoutAlign.lt-md="center center"
          class="title__sub-title"
        >
          <a
            [routerLink]="['/serviceRequest/details']"
            [queryParams]="{ status: 1 }"
          >
            <div>Abertura de O.S</div>
          </a>
        </div>
      </mat-card>
    </div>

    <div></div>
  </div>
</div>
<!--
<div class="container">
  <iframe
    src="http://app.bimachine.com.br/api/publisher/dashboard?content=%2Fnewasa%2Fsabara%2FDash.dashboard&showUpdateDate=true&showTitle=true&chart=false"
  ></iframe>
</div> -->
